export default function FilterChips({ options, value, onChange, testId }) {
  return (
    <div className="flex flex-wrap items-center gap-1.5" data-testid={testId}>
      {options.map((o) => {
        const active = value === o.value;
        return (
          <button
            key={o.value}
            type="button"
            onClick={() => onChange(o.value)}
            data-testid={`${testId}-${o.value}`}
            className={`flex items-center gap-1.5 px-3 h-8 rounded-full text-xs font-medium border transition-colors ${
              active
                ? "bg-[#10056E] text-white border-[#10056E]"
                : "bg-white text-slate-600 border-slate-200 hover:border-[#10056E] hover:text-[#10056E]"
            }`}
          >
            {o.label}
            {o.count !== undefined && (
              <span className={`px-1.5 py-0.5 rounded-full text-[10px] font-semibold leading-none ${active ? "bg-white/20" : "bg-slate-100"}`}>
                {o.count}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}
